import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: true,
  deployUrl: 'https://happy-hill-0c4c4691e.azurestaticapps.net/',
  useMockEnvironment: false
};
